<template>
  <!-- Fixed-width icon: the names line up whatever the file type. Not el-icon--left, whose
       el-icon- prefix switches the font to element-icons. -->
  <span>
    <i
      :class="[icon, 'fa-fw']"
      aria-hidden="true"
    /> {{ file.displayName }}
  </span>
</template>

<script>
import progressFile from '@/services/progressFile';

export default {
  name: 'ProgressFileName',
  props: {
    file: {
      type: Object,
      required: true,
    },
  },
  computed: {
    icon() {
      return progressFile.icon(this.file);
    },
  },
};
</script>
